import NewStockTake from "../../../../components/@documents/stock_takes/NewStockTake";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function StockTakeNewPage() {

    return (
        <NewStockTake 
            routeType={routeTypes.retail}
        />
    )
}